import { useState } from "react";

import api from "services/api.service";

export const useCaseFiles = () => {
  const [ files, setFiles ] = useState<File[]>([]);
  const [ fileAttachments, setFileAttachments ] = useState<number[]>([]);
  const [ filesUploadStatus, setFilesUploadStatus ] = useState<string[]>([]);
  const [ abortControllers, setAbortControllers ] = useState<AbortController[]>([]);
  const [ filesErrors, setFilesErrors ] = useState<{ error: boolean; fileName: string; }[]>([]);
  
  const onUploadFile = async (file: File) => {
    try {
      let attachments: number[] = [];

      setFilesUploadStatus(prevState => [
        ...prevState,
        file.name,
      ]);

      const controller = new AbortController();
      setAbortControllers(prevState => [ ...prevState, controller ]);

      const response = await api.uploadFile(file, undefined, controller);

      setFilesUploadStatus(prevState => [
        ...prevState.filter(fileName => fileName !== file.name),
      ]);

      attachments.push(response.id);

      setFileAttachments(prevState => [
        ...prevState,
        ...attachments,
      ]);
    } catch (err: Error | any) {
      if (err.name !== "CanceledError") {
        setFilesErrors(prevState => [ ...prevState, {
          fileName: file.name,
          error: true,
        } ]);
        setFilesUploadStatus(prevState => [
          ...prevState.filter(fileName => fileName !== file.name),
        ]);
      }
    }
  };

  const onRemoveFile = (index: number) => {
    const prevFiles = [ ...files ];
    const prevFileAttachments = [ ...fileAttachments ];
    const prevFilesUploadStatus = [ ...filesUploadStatus ];
    const fileToRemove = prevFiles.find((el, i) => i === index);

    setAbortControllers(prevState => [ ...prevState.filter((el, i) => {
      if (i === index) {
        el.abort();
      }

      return i !== index;
    }) ]);

    setTimeout(() => {
      setFiles(prevFiles.filter((file, i) => i !== index));
      setFileAttachments(prevFileAttachments.filter((fileId, i) => i !== index));
      setFilesUploadStatus(prevFilesUploadStatus.filter((fileName, i) => fileName !== fileToRemove?.name));
      setFilesErrors(prevState => [
        ...prevState.filter(({ fileName }) => fileName !== fileToRemove?.name),
      ]);
    }, 0);
  };

  return {
    files,
    setFiles,
    filesUploadStatus,
    onUploadFile,
    onRemoveFile,
    filesErrors,
    fileAttachments,
    setFileAttachments,
    setFilesUploadStatus,
  };
};
